import * as React from 'react';
import './styles.sass';

const PREFIX = 'jobs-successful-form';

export const JobsSuccessfulForm: React.StatelessComponent<any> = ({}) => (
  <div className={PREFIX}>
    <div className={`${PREFIX}__icon`}/>
    <div className={`${PREFIX}__info`}>
      <div className={`${PREFIX}__title`}>Thanks!</div>
      <div className={`${PREFIX}__text`}>
        Your application was received, and we'll get back to you soon.
      </div>
    </div>
  </div>
);
